import { store } from '@src/state/store';
import { getCurrentGame } from '@src/state/selectors/selector_game';
import { updatePlayerChoosingColor } from '@src/state/slices/slice_game';

import { Game } from '@src/lib/types';

export default () => (data: any) => {
  if (!data || !data.gameId || !data.playerId || !data.playerIndex) return;

  const game: Game | null = getCurrentGame(store.getState());
  if (game === null)
    throw new Error('[_chooseColor] game not found in root state');

  if (data.gameId == game.gameId) {
    store.dispatch(
      updatePlayerChoosingColor({
        gameId: game.gameId,
        playerId: data.playerId,
        playerIndex: data.playerIndex,
      }),
    );
  }
};
